import styled from '@emotion/styled';
// Theme 타입을 받아오는 함수 정의
const getThemeProp = (prop)=>(props)=>props.$theme[prop];
// CSS 변수를 사용하는 스타일드 컴포넌트 정의
export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background-color: var(--theme-bg, ${getThemeProp('background')});
  color: var(--theme-text, ${getThemeProp('text')});
  transition: background-color 0.2s ease, color 0.2s ease;
  position: relative;
  overflow-x: hidden;
  
  /* 모바일에서만 하단 패딩 적용 */
  @media (max-width: calc(${(props)=>props.$theme.breakpoints.md} - 1px)) {
    padding-bottom: 0;
  }
  
  /* 태블릿/데스크탑 화면에서는 그리드로 전환 */
  @media (min-width: ${(props)=>props.$theme.breakpoints.md}) {
    display: grid;
    grid-template-columns: var(--grid-template-columns, 68px 1fr auto);
    grid-template-areas: "sidebar main rightsidebar";
    grid-template-rows: 1fr;
    gap: 0;
    align-items: start;
    height: 100vh;
    overflow: hidden;
  }
  
  /* 큰 화면 (1024px 이상) */
  @media (min-width: ${(props)=>props.$theme.breakpoints.lg}) {
    grid-template-columns: var(--grid-template-columns, 275px 1fr auto);
  }
  
  /* VSCode 환경 조건부 스타일링 */
  ${(props)=>props.isVSCode && `
    height: auto;
    min-height: 0;
    max-width: 100%;
    overflow: visible !important;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none;
  `}

  /* 강의 모드 스타일 */
  ${(props)=>(props.isLectureMode || props.isFullScreenMode) && `
    @media (min-width: ${props.$theme.breakpoints.md}) {
        grid-template-columns: 1fr;
        grid-template-areas: "main";
    }
  `}
`;
export const SidebarContainer = styled.div`
  /* 모바일에서는 기본적으로 숨김 처리 */
  display: none;
  visibility: hidden;
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  left: -9999px;
  top: -9999px;
  pointer-events: none;
  
  @media (min-width: ${(props)=>props.$theme.breakpoints.md}) {
    display: grid;
    visibility: visible;
    width: 68px;
    height: 100vh;
    opacity: 1;
    position: sticky;
    left: unset;
    top: 0;
    pointer-events: auto;
    grid-area: sidebar;
    z-index: 5;
    border-right: 1px solid var(--theme-border, ${getThemeProp('border')});
    overflow: visible;
    padding: 0;
    align-self: stretch;
  }
  
  @media (min-width: ${(props)=>props.$theme.breakpoints.lg}) {
    width: 275px;
    padding: 0;
  }
`;
export const FixedInnerSidebar = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: var(--theme-paper, ${getThemeProp('paper')});
  box-sizing: border-box;
  padding: 0;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: var(--theme-paper-light, ${getThemeProp('paperLight')});
    border-radius: 10px;
  }
  scrollbar-width: thin;
  scrollbar-color: var(--theme-secondary, ${getThemeProp('secondary')})
                   var(--theme-paper-light, ${getThemeProp('paperLight')});
`;
export const MainContent = styled.main`
  grid-area: main;
  width: 100%;
  height: 100vh;
  background-color: var(--theme-paper, ${getThemeProp('paper')});
  position: relative;
  overflow-x: hidden;
  z-index: 1;
  overflow-y: auto;
  box-sizing: border-box;
  
  /* 모바일에서는 테두리 없음 */
  @media (max-width: calc(${(props)=>props.$theme.breakpoints.md} - 1px)) {
    border-left: none;
    border-right: none;
    padding-bottom: calc(3.25rem + env(safe-area-inset-bottom, 0px)); 
  }
  
  /* 태블릿 이상에서만 테두리 적용 */
  @media (min-width: ${(props)=>props.$theme.breakpoints.md}) {
    border-left: 1px solid var(--theme-border, ${getThemeProp('border')});
    border-right: none;
    padding-bottom: 0;
  }
  
  /* VSCode 환경 조건부 스타일링 */
  ${(props)=>props.isVSCode && `
    min-height: 0;
    
    @media (max-width: calc(${(props)=>props.$theme.breakpoints.md} - 1px)) {
        padding-bottom: calc(3.25rem + env(safe-area-inset-bottom, 0px)) !important;
        overflow-y: auto !important;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-track {
          background: transparent;
        }
        scrollbar-width: thin;
    }
    
    @media (min-width: ${(props)=>props.$theme.breakpoints.md}) {
       overflow-y: auto;
       &::-webkit-scrollbar {
         width: 4px; 
       }
       &::-webkit-scrollbar-track {
         background: transparent;
       }
       scrollbar-width: thin;
       scrollbar-color: transparent transparent;
    }
  `}
  
  /* 스크롤바 스타일링 (웹 환경용) */
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: var(--theme-paper-light, ${getThemeProp('paperLight')});
    border-radius: 10px;
  }
  scrollbar-width: thin;
  scrollbar-color: var(--theme-secondary, ${getThemeProp('secondary')})
                   var(--theme-paper-light, ${getThemeProp('paperLight')});
`;
export const RightSidebarContainer = styled.div`
  display: ${({ $isVisible })=>$isVisible ? 'flex' : 'none'};
  grid-area: rightsidebar;
  height: 100vh;
  width: ${({ $width })=>$width || 350}px;
  z-index: 5;
  background-color: var(--theme-paper, ${getThemeProp('paper')});
  overflow: hidden;
  flex-direction: column;
  border-left: 1px solid var(--theme-border, ${getThemeProp('border')});
  position: sticky;
  top: 0;
  
  /* 왼쪽 경계선을 리사이즈 핸들로 - 채팅 영역과 겹치지 않도록 조정 */
  &::before {
    content: '';
    position: absolute;
    left: -2px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: transparent;
    cursor: col-resize;
    z-index: 1;
    transition: all 0.2s ease;
    border-left: 2px solid transparent;
    pointer-events: auto;
    
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: rgba(59, 130, 246, 0.1);
        border-left-color: var(--theme-primary, ${getThemeProp('primary')});
      }
    }
    
    @media (hover: none) and (pointer: coarse) {
      background: rgba(59, 130, 246, 0.1);
      border-left: 2px solid rgba(59, 130, 246, 0.3);
      
      &:active {
        background: rgba(59, 130, 246, 0.2);
        border-left-color: var(--theme-primary, ${getThemeProp('primary')});
      }
    }
  }
  
  /* 리사이즈 핸들에 점선 표시자 추가 */
  &::after {
    content: '';
    position: absolute;
    left: 1px;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 20px;
    background-image: repeating-linear-gradient(
      to bottom,
      transparent,
      transparent 2px,
      var(--theme-text-secondary, rgba(107, 114, 128, 0.6)) 2px,
      var(--theme-text-secondary, rgba(107, 114, 128, 0.6)) 4px
    );
    opacity: 0;
    transition: opacity 0.2s ease;
    pointer-events: none;
    z-index: 11;
  }
  
  &:hover::after {
    @media (hover: hover) and (pointer: fine) {
      opacity: 1;
    }
  }
  
  &.resizing::after {
    opacity: 1;
  }
  
  &.resizing::before {
    background: rgba(59, 130, 246, 0.3);
    border-left-color: var(--theme-primary, ${getThemeProp('primary')});
    width: 2px;
  }
  
  &.resizing {
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  }
`;
export const MobileNavigation = styled.nav`
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3.25rem;
  background-color: var(--theme-paper, ${getThemeProp('paper')});
  border-top: 1px solid var(--theme-border, ${getThemeProp('border')});
  z-index: 50;
  
  @media (min-width: ${(props)=>props.$theme.breakpoints.md}) {
    display: none;
  }
`;
// 기본 styled components들
export const SidebarToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  border-radius: ${getThemeProp('radius')}.sm;
  color: var(--theme-text, ${getThemeProp('text')});
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: var(--theme-paper-hover, ${getThemeProp('paperHover')});
  }
  
  &:active {
    background-color: var(--theme-paper-active, ${getThemeProp('paperActive')});
  }
`;
export const MobileRightSidebarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 40;
  
  @media (min-width: ${(props)=>props.$theme.breakpoints.md}) {
    display: none;
  }
`;
export const MobileRightSidebarBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 35;
`;
export const MobileRightSidebarPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  max-width: 24rem;
  height: 100vh;
  background-color: var(--theme-paper, ${getThemeProp('paper')});
  z-index: 45;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  
  &.open {
    transform: translateX(0);
  }
`;
export const ChatHeader = styled.div`
  padding: ${getThemeProp('spacing')}.md;
  border-bottom: 1px solid var(--theme-border, ${getThemeProp('border')});
  background-color: var(--theme-paper, ${getThemeProp('paper')});
`;
export const ChatTabContainer = styled.div`
  display: flex;
  gap: ${getThemeProp('spacing')}.sm;
`;
export const ChatTabButton = styled.button`
  padding: ${getThemeProp('spacing')}.sm ${getThemeProp('spacing')}.md;
  border: none;
  border-radius: ${getThemeProp('radius')}.sm;
  background-color: ${({ $isActive })=>$isActive ? `var(--theme-primary, ${getThemeProp('primary')})` : 'transparent'};
  color: ${({ $isActive })=>$isActive ? 'white' : `var(--theme-text, ${getThemeProp('text')})`};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background-color: ${({ $isActive })=>$isActive ? `var(--theme-primary, ${getThemeProp('primary')})` : `var(--theme-paper-hover, ${getThemeProp('paperHover')})`};
  }
`;
export const ChatContentContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: ${getThemeProp('spacing')}.md;
`;
